// extracted by mini-css-extract-plugin
export default {"text":"Text_text__wZ6pM","text__list":"Text_text__list__N-CMa","text__education":"Text_text__education__gaCGf"};